import React from 'react';
import KoIcon from '@kwapio/icons';
import styles from './files.module.scss';


const FileTypeIcon = ({ type, size = 20 }) => {
  if (!type) return null;

  const lowerType = type.toLowerCase();

  const iconMap = [
    { match: 'image', name: 'FileImageOutlined' },
    { match: 'video', name: 'VideoFileOutlined' },
    { match: 'audio', name: 'AudioFileOutlined' },
    { match: 'pdf', name: 'PdfOutlined', size: 17 },
    { match: 'zip', name: 'ZipFilled' },
    { match: 'xlsx', name: 'XLSFileOutlined' },
    { match: 'csv', name: 'XLSFileOutlined' },
    { match: 'docx', name: 'FileOutlined' },
    { match: 'txt', name: 'FileOutlined' },
    { match: 'ppt', name: 'PPTFileOutlined' },
    { match: 'whiteboard', name: 'FileOutlined' },
    { match: 'code', name: 'CodeOutlined' },
    { match: 'json', name: 'CodeOutlined' },
    { match: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', name: 'FileOutlined' }
  ];

  const matchedIcon = iconMap.find(({ match }) => lowerType.includes(match));

  if (!matchedIcon) return null;

  return (
    <div className={styles.circle}>
      <KoIcon
        name={matchedIcon.name}
        width={matchedIcon.size || size}
        height={matchedIcon.size || size}
      />
    </div>
  );
};

export default FileTypeIcon;
